module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hans_kyushu-0dce4171da431e8bd93c434e5ae03b85.jpg";